import { Component, OnInit } from '@angular/core';

import { UserService } from '../../../../shared/services/user/user.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-assignment-type-dropdown',
  templateUrl: '../template-dropdown.html'
})
export class AssignmentTypeDropdownComponent extends DropdownBaseComponent implements OnInit {

  constructor(
    private readonly dropdownService: DropDownService,
    protected readonly translatorService: TranslatorService
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    this.itemsData = [
      { id: 'manual', name: 'Manual' },
      { id: 'competitive', name: 'Competitiva' },
      { id: 'prequalification', name: 'Precualificación Competitiva' }
    ];
  }

}
